var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#99BEA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.938C24.0173 28.6813 25.8611 27.6661 27.1568 26.0988C28.4525 24.5314 29.1027 22.5295 28.9754 20.5C28.848 18.4704 27.9527 16.5655 26.4713 15.1724C24.9898 13.7793 23.0336 13.0025 21 13C18.964 12.9985 17.0039 13.7733 15.5193 15.1667C14.0347 16.56 13.1372 18.467 13.0097 20.499C12.8822 22.5311 13.5343 24.5353 14.8331 26.1033C16.132 27.6712 17.9797 28.685 20 28.938V23H18V21H20V19.346C20 18.009 20.14 17.524 20.4 17.035C20.6561 16.5512 21.052 16.1557 21.536 15.9C21.918 15.695 22.393 15.572 23.223 15.519C23.552 15.498 23.978 15.524 24.501 15.599V17.499H24C23.083 17.499 22.704 17.542 22.478 17.663C22.3431 17.7324 22.2334 17.8421 22.164 17.977C22.044 18.203 22 18.427 22 19.345V21H24.5L24 23H22V28.938ZM21 31C15.477 31 11 26.523 11 21C11 15.477 15.477 11 21 11C26.523 11 31 15.477 31 21C31 26.523 26.523 31 21 31Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.701b1dcbfb5c124e243c205b8284d9c3.svg";
export { ForwardRef as ReactComponent };